import {
  LuggageIcon,
  VenusIcon,
  MarsIcon,
  GemIcon,
  BabyIcon,
  HeartPulse,
  SproutIcon,
  DumbbellIcon,
  CableIcon,
  PawPrint,
} from 'lucide-react';
import { CategoryProps } from 'types/categories';
import { Category } from './enums';

export const categories: Record<Category, CategoryProps> = {
  [Category.WomensFashion]: {
    i18nKey: 'category.womens_fashion',
    Icon: VenusIcon,
    color: '#FF69B4',
  },
  [Category.MensFashion]: {
    i18nKey: 'category.mens_fashion',
    Icon: MarsIcon,
    color: '#4169E1',
  },
  [Category.JewelryAccessories]: {
    i18nKey: 'category.jewelry_accessories',
    Icon: GemIcon,
    color: '#FFC700',
  },
  [Category.KidsBabies]: {
    i18nKey: 'category.kids_babies',
    Icon: BabyIcon,
    color: '#00AA8D',
  },
  [Category.BeautyHealth]: {
    i18nKey: 'category.beauty_health',
    Icon: HeartPulse,
    color: '#FF6B6B',
  },
  [Category.HomeGarden]: {
    i18nKey: 'category.home_garden',
    Icon: SproutIcon,
    color: '#00D200',
  },
  [Category.SportsEntertainment]: {
    i18nKey: 'category.sports_entertainment',
    Icon: DumbbellIcon,
    color: '#4682B4',
  },
  [Category.BagsLuggage]: {
    i18nKey: 'category.bags_luggage',
    Icon: LuggageIcon,
    color: '#DEB887',
  },
  [Category.ConsumerElectronics]: {
    i18nKey: 'category.consumer_electronics',
    Icon: CableIcon,
    color: '#461bac',
  },
  [Category.Pets]: {
    i18nKey: 'category.pets',
    Icon: PawPrint,
    color: '#c415f4',
  },
};
